<template>
  <footer class="footer">
   <b-container>
      <b-row class="justify-content-between">
        <b-col cols="7">
          <div class="d-flex flex-column">
            <h4 class="footer__contact">{{ $t("contactUs.title") }}</h4>
            <a class="footer__item" href="mailito:hello@makeamolecule.com">
              hello@makeamolecule.com</a>
            <a class="footer__item" href="+41446332103">+41 44 633 21 03</a>
          </div>
        </b-col>
        <b-col cols="4" class="text-right">
          <div class="d-flex flex-column flex-sm-row justify-content-end">
            <a class="footer__ico" href="https://www.facebook.com/makeamolecule/" target="_blank"><i class="fab fa-facebook-f"></i></a>
            <a class="footer__ico" href="https://www.instagram.com/makeamolecule/" target="_blank"><i class="fab fa-instagram"></i></a>
            <a class="footer__ico" href="https://twitter.com/MakeAMolecule" target="_blank"><i class="fab fa-twitter"></i></a>
          </div>
        </b-col>
      </b-row>
      <b-navbar toggleable="true">
        <b-navbar-nav v-if="!!categoriesList[0]">
          <b-nav-item :to="{ name: 'home' }" v-scroll-to="'#scrollToOnLoad'">
            {{ $t("nav.home") }}
          </b-nav-item>
            <b-nav-item-dropdown id="nav7_ddown" v-if="!!categoriesList[0]"
              :text="$t('nav.whatINeedToKnow')">
              <b-dropdown-item
                  v-for="article in sortedArticles"
                  :key="article.id"
                  :to="{ path: `/need_to_know/${article.id}`}"
                  v-scroll-to="'#scrollToOnLoad'">
                {{ article.title }}</b-dropdown-item>
              </b-nav-item-dropdown>
            <b-nav-item-dropdown id="nav7_ddown" text="Experiment">
            <b-dropdown-item :to="{ name: 'login' }" v-scroll-to="'#scrollToOnLoad'">
            {{ $t("nav.logIn") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'prev_results' }" v-scroll-to="'#scrollToOnLoad'"
              v-if="isUserLoggedIn">
              {{ $t("nav.previouseResults") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'building_blocks' }" v-scroll-to="'#scrollToOnLoad'"
            v-if="isUserLoggedIn">
              {{ $t("nav.chooseMyBuldingBlocks") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'report_my_results' }"
              v-scroll-to="'#scrollToOnLoad'"
              v-if="isUserLoggedIn">
              {{ $t("nav.reportResults") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'students_list' }"
              v-scroll-to="'#scrollToOnLoad'"
              v-if="isUserLoggedIn && userRole === 'teacher'">
              {{ $t("nav.studentsList") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'support' }" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.technicalSupport") }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown id="nav7_ddown" :text="$t('nav.iLoveScience')" >
            <b-dropdown-item :to="{ name: 'science_in_school' }" v-scroll-to="'#scrollToOnLoad'">
                {{ $t("nav.scienceInSchool") }}</b-dropdown-item>
            <b-dropdown-item
              v-if="!!categoriesList[1]"
              v-for="article in categoriesList[1].articles"
              :key="article.id"
              :to="{ path: `/i_love_science/${article.id}`}"
              v-scroll-to="'#scrollToOnLoad'">
                  {{ article.title }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'careers' }" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.careersInScience") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ask_a_scientist' }" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.askAScientist") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'learn_more' }" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.whereCanILearnMore") }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item :to="{ name: 'news' }" v-scroll-to="'#scrollToOnLoad'">
            {{ $t("nav.news") }}</b-nav-item>
          <b-nav-item :to="{ name: 'contact_us' }" v-scroll-to="'#scrollToOnLoad'">
            {{ $t("nav.contactUs") }}
          </b-nav-item>
          <b-nav-item-dropdown id="nav7_ddown" text="My account">
            <b-dropdown-item :to="{ name: 'user_profile' }" v-scroll-to="'#scrollToOnLoad'"
            v-if="isUserLoggedIn">
              {{ $t("nav.userProfile") }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'account_details' }" v-scroll-to="'#scrollToOnLoad'"
            v-if="isUserLoggedIn">
              {{ $t("nav.accountDetails") }}</b-dropdown-item>
            <b-dropdown-item v-if="isUserLoggedIn">{{ $t("nav.logOut") }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </b-container>
     <b-container class="container--wide">
      <b-row class="mt-5">
        <b-col cols="6" sm="4">
          <a href="#"><img class="img-fluid" src="../../assets/ethz-logo.svg" alt=""></a>
        </b-col>
        <b-col cols="6" sm="4" offset-sm="4">
          <a href="#"><img class="img-fluid" src="../../assets/logo-footer.svg" alt=""></a>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          <span class="footer__copyright">
            Copyright &copy; 2017 Agora.com, Inc. All rights reserved.
          </span>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import auth from '@/api/v1/auth';
import categories from '@/api/v1/categories';

export default {
  data() {
    return {
      userRole: auth.user.user_type,
      categoriesList: [],
      isUserLoggedIn: auth.user.authenticated,
    };
  },
  computed: {
    sortedArticles() {
      return this.categoriesList[0].articles.concat().sort((a, b) => a.position - b.position);
    },
  },
  methods: {
    getCategories() {
      const succ = (response) => {
        this.categoriesList = response.data.categories;
      };
      categories.index(succ);
    },
  },
  created() {
    this.getCategories();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/helpers/_variables.scss';

.footer {
  background-color: $color--navy-blue;
  padding: 45px 0;
  &__contact {
    font-size: 30px;
    padding-bottom: 5px;
  }
  &__item {
  font-size: 14px;
  line-height: 21px;
  padding-bottom: 5px;
  }
  &__ico {
    margin-left: 5px;
    svg{
      width: 20px;
      height: 20px;
    }
  }
  &__copyright {
    font-size: 13px;
    text-align: center;
    color: $color--white;
    border-top: 3px solid $color--white;
    width: 100%;
    margin-top: 10px;
    padding: 17px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/FooterMobile.vue